var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center flex-grow-1"},[_c('v-toolbar-title',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.pTitle))]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }